module.exports = __webpack_public_path__ + "static/media/share-icon4.5be7ef72.svg";